export default "__VITE_ASSET__5e48bf6c__"